import React, { useEffect, useRef, useState } from 'react';
import { EditControlButtonStyles } from './styles/EditControlButton.styles';
import { useDispatch } from 'react-redux';
import { theme } from '../../../../core/theme/theme';

interface EditControlButtonProps {
    id: string;
    tooltipTxt: string;
    state?: any;
    setState?: any;
    dependenceState?: boolean;
    ternaryText?: string;
    icon?: string;
    text?: string;
    MenuComponent?: any;
    menuProps?: any;
    backgroundSize?: string | undefined;
    isDisabled?: boolean;
    // hasExternalCloseButton?: boolean;
}
const EditControlButton: React.FC<EditControlButtonProps> = ({
    id,
    tooltipTxt,
    state,
    setState,
    dependenceState,
    ternaryText,
    icon,
    text,
    MenuComponent,
    menuProps,
    backgroundSize,
    isDisabled,
    // hasExternalCloseButton,
}) => {
    const buttonRef = useRef(null);
    const dispatch = useDispatch();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleMouseOver = (id: string) => {
        (document.getElementById(`${id}`) as HTMLInputElement).style.backgroundColor = theme.colors.hover_color;
    };
    const handleMouseLeave = (id: string) => {
        (document.getElementById(`${id}`) as HTMLInputElement).style.backgroundColor =
            state || isMenuOpen ? theme.colors.hover_color : theme.colors.default;
    };

    useEffect(() => {
        //@ts-ignore
        buttonRef.current.addEventListener('mousedown', (e) => e.stopPropagation());
    }, []);

    // useEffect(() => {
    //     if (hasExternalCloseButton && !state && setState) {
    //         handleMouseLeave(id);
    //     }
    // }, [state]);

    return (
        <div style={{ display: MenuComponent && 'flex', flexDirection: 'row-reverse' }}>
            <div>
                <button
                    ref={buttonRef}
                    id={id}
                    title={tooltipTxt}
                    onClick={() => {
                        if (!dependenceState && setState) {
                            dispatch(setState(!state));
                            MenuComponent && setIsMenuOpen(!isMenuOpen);
                        } else if (dependenceState === undefined) {
                            MenuComponent && setIsMenuOpen(!isMenuOpen);
                        }
                    }}
                    onMouseOver={() => handleMouseOver(id)}
                    onMouseLeave={() => handleMouseLeave(id)}
                    style={EditControlButtonStyles(icon, backgroundSize).Button}
                    disabled={isDisabled}
                >
                    {ternaryText && ternaryText}
                    {text && <div>{text}</div>}
                </button>
            </div>
            {MenuComponent && isMenuOpen && !dependenceState && (
                <div>{menuProps ? <MenuComponent menuProps={menuProps} /> : <MenuComponent />}</div>
            )}
        </div>
    );
};

export default EditControlButton;
// const [isButtonActive, setIsButtonActive] = useState(false);
// isToggleButton && dispatch(setState(!state));
// !isToggleButton && dispatch(setState(true));
// setIsButtonActive(!isButtonActive);
